import axios from 'axios';

import {
    PENDING_IMPLANT_LIST_REQUEST,
    PENDING_IMPLANT_LIST_SUCCESS,
    PENDING_IMPLANT_LIST_FAIL,

    PENDING_IMPLANT_DETAILS_REQUEST,
    PENDING_IMPLANT_DETAILS_SUCCESS,
    PENDING_IMPLANT_DETAILS_FAIL,

    PENDING_IMPLANT_DELETE_REQUEST,
    PENDING_IMPLANT_DELETE_SUCCESS,
    PENDING_IMPLANT_DELETE_FAIL,

    PENDING_IMPLANT_CREATE_REQUEST,
    PENDING_IMPLANT_CREATE_SUCCESS,
    PENDING_IMPLANT_CREATE_FAIL,

    PENDING_IMPLANT_UPDATE_REQUEST,
    PENDING_IMPLANT_UPDATE_SUCCESS,
    PENDING_IMPLANT_UPDATE_FAIL,

    PENDING_IMPLANT_APPROVE_REQUEST,
    PENDING_IMPLANT_APPROVE_SUCCESS,
    PENDING_IMPLANT_APPROVE_FAIL,

    PENDING_IMPLANT_REJECT_REQUEST,
    PENDING_IMPLANT_REJECT_SUCCESS,
    PENDING_IMPLANT_REJECT_FAIL,
} from "../constants/pendingImplantConstants";

export const listPendingImplants = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: PENDING_IMPLANT_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${userInfo.token}`
            },
            params
        }
        const { data } = await axios.get('/api/v1/pendingimplant/all', config);

        dispatch({
            type: PENDING_IMPLANT_LIST_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: PENDING_IMPLANT_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : "An error occurred, please try again later",
        });
    }
}

export const getPendingImplantDetails = (_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PENDING_IMPLANT_DETAILS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`/api/v1/pendingimplant/${_id}`, config);

        dispatch({
            type: PENDING_IMPLANT_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            if (error.response.data.errors) {
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }
        dispatch({
            type: PENDING_IMPLANT_DETAILS_FAIL,
            payload: errorMessages,
        });
    }
}

export const createPendingImplant = (changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PENDING_IMPLANT_CREATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.post(
            `/api/v1/pendingimplant/`,
            changes,
            config
        )

        dispatch({
            type: PENDING_IMPLANT_CREATE_SUCCESS,
            payload: data,
        })

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            if (error.response.data.errors) {
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }
        dispatch({
            type: PENDING_IMPLANT_CREATE_FAIL,
            payload: errorMessages,
        })
    }
}

export const updatePendingImplant = (_id, changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PENDING_IMPLANT_UPDATE_REQUEST
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const response = await axios.patch(
            `/api/v1/pendingimplant/${_id}/`,
            changes,
            config
        );

        dispatch({
            type: PENDING_IMPLANT_UPDATE_SUCCESS,
            payload: response.data,
        });

        dispatch({
            type: PENDING_IMPLANT_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            if (error.response.data.errors) {
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }
        dispatch({
            type: PENDING_IMPLANT_UPDATE_FAIL,
            payload: errorMessages,
        });
    }
};

export const deletePendingImplant = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PENDING_IMPLANT_DELETE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.delete(
            `/api/v1/pendingimplant/${_id}/`,
            config
        )

        dispatch({
            type: PENDING_IMPLANT_DELETE_SUCCESS,
        })

    } catch (error) {
        dispatch({
            type: PENDING_IMPLANT_DELETE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const approvePendingImplant = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PENDING_IMPLANT_APPROVE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.post(
            `/api/v1/pendingimplant/${_id}/approve`,
            {},
            config
        )

        dispatch({
            type: PENDING_IMPLANT_APPROVE_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: PENDING_IMPLANT_APPROVE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const rejectPendingImplant = (_id, rejectionReason) => async (dispatch, getState) => {
    try {
        dispatch({
            type: PENDING_IMPLANT_REJECT_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.post(
            `/api/v1/pendingimplant/${_id}/reject`,
            { rejectionReason },
            config
        )

        dispatch({
            type: PENDING_IMPLANT_REJECT_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: PENDING_IMPLANT_REJECT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

